export default "__VITE_ASSET__bfr79bNC__"